import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { PaymentDetails, PickupType, SendMoneyDetail } from '../../../models/sendmoney/sendmoney';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../../sharedcomponents/commonservice/countrylist.service';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';

enum actionType {
  continue = 1,
  moreInfo = 2,
}

export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-agent-popup',
  templateUrl: './agent-popup.component.html',
  providers: [AlertService, Modal, CountryService],
})

export class AgentDetailModalComponent implements OnInit, ModalComponent<CustomModalContext> {
  sendMoneyDetail: SendMoneyDetail;
  agentpopupData: any = {};
  context: CustomModalContext;
  action: actionType;
  enumPickupType: any;
  paymentDetails: typeof PaymentDetails;
 
 // paymentDetails: PaymentDetails;
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    public sendMoneyService: SendMoneyService,
    public translate: TranslateService
  
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    let dem: Number;
    this.context = dialog.context;
    this.enumPickupType = PickupType;
    this.paymentDetails= PaymentDetails;
    this.sendMoneyDetail = new SendMoneyDetail();

  
    dem= this.sendMoneyDetail.paymentDetails.minimumDenomination;

    console.log(dem);
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    
      dem= this.sendMoneyDetail.paymentDetails.minimumDenomination;
      // if(this.sendMoneyDetail.paymentDetails.minimumDenomination>0){

      // }
    });
    
  }
  ngOnInit() {

  }

  moreInfoClick() {
    this.dialog.close();
    this.context.modalData.next = 'agentdetails';
  }

  continueClick() {
    this.context.modalData.next = 'continue';
    this.dialog.close();
  }
  closeClick() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_modalpopup/agent-popup/agent-popup.component.ts